// Generated by Melange

import * as Buhta_conf__Config from "../../../packages/conf/lib/Config.js";
import * as Buhta_core__GlobalStateContext from "../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_router__Common from "../../../packages/router/lib/Common.js";
import * as Buhta_router__LandingRoute from "../../../packages/router/lib/LandingRoute.js";
import * as ReasonReactRouter from "reason-react/ReasonReactRouter.js";

function toAbsoluteString(route) {
  const cfg = Buhta_conf__Config.getConfig(undefined);
  return cfg.app_url + Buhta_router__LandingRoute.toString(route);
}

function useUrl(param) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const serverUrl = Buhta_router__Common.prepareServerUrl(state.serverUrl);
  return ReasonReactRouter.useUrl(serverUrl, undefined);
}

function getCountry(param) {
  const route = Buhta_router__LandingRoute.ofUrl(useUrl(undefined));
  if (/* tag */ typeof route === "number" || typeof route === "string" || route.TAG !== /* Landing */ 0) {
    return /* COUNTRY_KAZ */ 1;
  } else {
    return route._0;
  }
}

function getLanguage(param) {
  const route = Buhta_router__LandingRoute.ofUrl(useUrl(undefined));
  if (/* tag */ typeof route === "number" || typeof route === "string" || route.TAG !== /* Landing */ 0) {
    return /* Ru */ 1;
  } else {
    return route._1;
  }
}

const getRouterUrl = Buhta_router__Common.getRouterUrl;

const prepareServerUrl = Buhta_router__Common.prepareServerUrl;

const isProtected = Buhta_router__Common.isProtected;

const isNotFound = Buhta_router__Common.isNotFound;

const isLanding = Buhta_router__Common.isLanding;

const isApp = Buhta_router__Common.isApp;

const toString = Buhta_router__LandingRoute.toString;

const getLanguageRoute = Buhta_router__LandingRoute.getLanguageRoute;

const getLocalRoute = Buhta_router__LandingRoute.getLocalRoute;

const ofUrl = Buhta_router__LandingRoute.ofUrl;

const isOrgOrAdminRoute = Buhta_router__LandingRoute.isOrgOrAdminRoute;

const navigateTo = Buhta_router__LandingRoute.navigateTo;

const updateBrowserLocation = Buhta_router__LandingRoute.updateBrowserLocation;

const urlWithParams = Buhta_router__LandingRoute.urlWithParams;

const setUrlParams = Buhta_router__LandingRoute.setUrlParams;

const getParamValue = Buhta_router__LandingRoute.getParamValue;

const useParamValue = Buhta_router__LandingRoute.useParamValue;

const dispatchPopStateEvent = Buhta_router__LandingRoute.dispatchPopStateEvent;

export {
  getRouterUrl,
  prepareServerUrl,
  isProtected,
  isNotFound,
  isLanding,
  isApp,
  toString,
  getLanguageRoute,
  getLocalRoute,
  ofUrl,
  isOrgOrAdminRoute,
  navigateTo,
  updateBrowserLocation,
  urlWithParams,
  setUrlParams,
  getParamValue,
  useParamValue,
  dispatchPopStateEvent,
  toAbsoluteString,
  useUrl,
  getCountry,
  getLanguage,
}
/* Buhta_conf__Config Not a pure module */
